import React, { useState, useEffect } from "react";

const MediaUploader = ({ onUpdate, existingMedia = [], sectionKey }) => {
  const [mediaList, setMediaList] = useState(existingMedia);
  console.log(existingMedia);
  

  useEffect(() => {
    onUpdate(mediaList);
  }, [mediaList, onUpdate]);

  const openWidget = () => {
    if (!window.cloudinary) {
      alert("Cloudinary script not loaded yet!");
      return;
    }

    const IMAGE_MAX = 4 * 1024 * 1024; // 4 MB
    const VIDEO_MAX = 50 * 1024 * 1024; // 50 MB

    window.cloudinary.openUploadWidget(
      {
        cloudName: process.env.REACT_APP_CLOUDINARY_NAME,
        uploadPreset: process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET,
        apiKey: process.env.REACT_APP_CLOUDINARY_API_KEY,
        sources: ["local"],
        multiple: true,
        resourceType: "auto",
        clientAllowedFormats: ["PNG", "JPG", "JPEG", "MP4", "MOV"],
        maxFileSize: VIDEO_MAX,
        max_file_size: VIDEO_MAX,
        maxImageFileSize: IMAGE_MAX,
        maxVideoFileSize: VIDEO_MAX,
      },
      (error, result) => {
        if (!error && result && result.event === "success") {
            const info = result.info;
            const size = info.bytes || info.size || 0;
            // double-check against limits in case widget allowed the file
            if (info.resource_type === 'image' && size > IMAGE_MAX) {
              alert('Image exceeds maximum allowed size of 4 MB. Upload rejected.');
              return;
            }

            if (info.resource_type === 'video' && size > VIDEO_MAX) {
              alert('Video exceeds maximum allowed size of 50 MB. Upload rejected.');
              return;
            }
          const newResource = {
            cloudinary_public_id: info.public_id,
            cloudinary_url: info.secure_url,
            resource_type: info.resource_type,
            format: info.format,
            width: info.width,
            height: info.height,
            duration: info.duration || 0,
            display_order: mediaList.length + 1,
            caption: info.original_filename || "",
            is_active: true,
          };
          setMediaList((prev) => [...prev, newResource]);
        }
      }
    );
  };

  const removeItem = (index) => {
    setMediaList((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <div style={{ border: "1px dashed #ccc", padding: "20px", borderRadius: "8px" }}>
      <button type="button" onClick={openWidget} style={btnStyle}>
        Add Media (Images/Videos)
      </button>
      
        <div style={{ color: '#666', fontSize: '12px', marginBottom: '12px' }}>
          {`${sectionKey==='hero-banner'?'Recommended Hero Banner: 1240×500 px. ':''}Allowed formats: Images - JPG, JPEG, PNG (max 4 MB) | Videos - MP4, MOV (max 50 MB).`}
        </div>
  

      <div style={gridStyle}>
        {mediaList.map((item, index) => (
          <div key={index} style={cardStyle}>
            {item.resource_type === "image" ? (
              <img src={item.url || item.cloudinary_url} alt="upload" style={mediaStyle} />
            ) : (
              <video src={item.url || item.cloudinary_url} style={mediaStyle} controls={false} />
            )}
            <button 
              onClick={() => removeItem(index)} 
              style={deleteBtnStyle}
              title="Remove"
            >
              ×
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

const btnStyle = { padding: "10px 20px", cursor: "pointer", marginBottom: "15px" };
const gridStyle = { display: "flex", flexWrap: "wrap", gap: "10px" };
const cardStyle = { position: "relative", width: "120px", height: "120px", border: "1px solid #eee" };
const mediaStyle = { width: "100%", height: "100%", objectFit: "cover" };
const deleteBtnStyle = { 
  position: "absolute", top: "-5px", right: "-5px", 
  background: "red", color: "white", border: "none", 
  borderRadius: "50%", width: "25px", height: "25px", cursor: "pointer" 
};

export default MediaUploader;